import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { IS_PRO, Config } from './config'
import { getCookie } from './cookie'
import sentryIgnoreErrors from './sentryIgnoreErrors'

export const initSentry = () => {
  //只在正式环境上报
  if (!IS_PRO) {
    return
  }
  Sentry.setUser({ username: getCookie('cocofaxName') })
  Sentry.init({
    environment: process.env.REACT_APP_SECRET_BUILD_TYPE,
    dsn: Config.sentryConfig.dsn,
    autoSessionTracking: true,
    ignoreErrors: sentryIgnoreErrors, //更多在sentry后台Inbound Filters直接配置
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0, // 0-1之间, 0不上报性能监控
  })
}
